// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".barcode-wrapper[data-v-7733bae2]{text-align:center;width:100%}.barcode-wrapper svg[data-v-7733bae2],.barcode-wrapper>*[data-v-7733bae2]{width:100%}.barcode-wrapper .error[data-v-7733bae2]{color:#e87e11;font-size:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
